import { IAlertHandlerState } from 'modules/alertHandler/interfaces';
import { CONTAINERS_LIST } from 'shared/enums';

const matchPermissionRules = {
  [CONTAINERS_LIST.EPS]: 'eps:',
  [CONTAINERS_LIST.REMUNERATION]: 'remuneration-',
  [CONTAINERS_LIST.MAILING]: 'mailing-rule:|strategy:',
  mailingRules: 'mailing-rule:',
  strategy: 'strategy:',
  [CONTAINERS_LIST.SETTINGS]: 'identity:|policy:',
  identity: 'identity:',
  policy: 'policy:',
  [CONTAINERS_LIST.EXEMPTION]: 'exemption:',

  [CONTAINERS_LIST.RESULT]:
    'remunerationEpsTotal:|remunerationServiceCategoryTotal:',

  remunerationDetails: 'remunerationDetails',
  remunerationEpsTotal: 'remunerationEpsTotal',
  remunerationServiceCategoryTotal: 'remunerationServiceCategoryTotal',
  remunerationSubDetails: 'remunerationSubDetails',

  debt: 'debt',
  contract: 'contract',
  customer: 'customer',
  invoice: 'invoice',
  offer: 'offer',
  operation: 'operation',
  resource: 'resource',
};

const hasPermissionByRegex = (value: string, allPermissions: string): boolean =>
  !!allPermissions.match(new RegExp(value));

const getMenuPermissions = (
  permissions: string,
): { [key: string]: boolean } => {
  const permissionRulesEntries = Object.entries(matchPermissionRules);

  return permissionRulesEntries.reduce(
    (t, c) => ({ ...t, [c[0]]: hasPermissionByRegex(c[1], permissions) }),
    {},
  );
};

export const getParsedPermissions = (
  permissionList: string[],
): { [key: string]: boolean } => {
  const permissions = permissionList.join(';');

  const parsedPermissions = getMenuPermissions(permissions);

  return permissionList.reduce(
    (t, c) => ({ ...t, [c]: true }),
    parsedPermissions,
  );
};

const userLoginErrorMessages = {
  '401': {
    title: 'Não foi possível conectar ao sistema...',
    content: 'Usuário ou senha incorretos, por favor tente novamente.',
  },
  'without-response': {
    title: 'Ocorreu algum problema.',
    content: 'Sem conexão com o servidor, por favor tente mais tarde...',
  },
  default: {
    title: 'Erro!',
    content: 'Chave inválida',
  },
} as { [key: string]: IAlertHandlerState };

export const userLoginActionFailedMessageByError = (
  errorCode: string | number,
): IAlertHandlerState =>
  userLoginErrorMessages[String(errorCode)] || userLoginErrorMessages.default;
